import React, { useEffect, useState } from "react";
import SideModal from "@/common/components/CustomModal/SideModal";
import ClipboardCopy from "@/common/components/ClipboardCopy";
import CustomButton from "@/common/components/CustomButton";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import routes from "@/common/routes";
import ModalTitleHeader from "@/common/components/ModalTitleHeader";
import ModalNavLinks from "../../../../components/ModalNavLinkFunding";
import Language from "@/common/utils/language/en";
import { Select, SelectItem } from "@/common/components/CustomSelect";
import {
  BLOCKCHAIN_ASSEST,
  BLOCKCHAIN_NETWORKS,
} from "@/common/utils/helpers/networks";
import {
  useGetCommisionWalletQuery,
  useGetKycWalletQuery,
  useGetTreasuryWalletQuery,
} from "@/module/wallet/service/api";
import { getCurrentWalletType } from "@/common/utils/helpers";

const { FundCryptoForm: PageDictionary } =
  Language.protected.walletModals.funding;

function FundCryptoForm() {
  const { appid } = useParams();
  const navigate = useNavigate();
  const location = useLocation().state?.background;
  const currentWallet = getCurrentWalletType(location?.pathname) ?? "treasury";

  const WALLETS = {
    treasury: useGetTreasuryWalletQuery,
    commission: useGetCommisionWalletQuery,
    kyc: useGetKycWalletQuery,
  };

  const { data, isLoading: loading } = WALLETS[currentWallet](appid!, {
    skip: !appid,
  });

  const [network, setNetwork] = useState<string>("");
  const [asset, setAsset] = useState("");

  const MOBCOIN_WALLET = data?.data?.address;
  const EUSD_WALLET = data?.data?.meta_data?.eusd_address;

  const isWalletPresent = MOBCOIN_WALLET && EUSD_WALLET ? true : false;

  const backDropHandler = () => {
    if (appid) {
      const path =
        location?.pathname ??
        routes.protected.applications.app.wallet.link(appid);
      navigate(path, { replace: true });
    }
  };

  const selectHandler = (val: string) => {
    setNetwork(val);
  };

  const submitHandler = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    backDropHandler();
  };

  useEffect(() => {
    setNetwork("");
  }, [asset]);

  return (
    <SideModal
      className="p-8 md:pt-22 md:pl-15 md:pr-28"
      onclickBackDrop={backDropHandler}
    >
      <ModalTitleHeader
        title={PageDictionary.header.title}
        subtitle={PageDictionary.header.subtitle}
      />
      <form onSubmit={submitHandler} className="flex flex-col gap-y-5 pt-9">
        <ModalNavLinks />
        {/* <CustomInput
          label={PageDictionary.form.coin_label}
          value={data?.crypto_symbol ? data.crypto_symbol : ""}
          readOnly
        /> */}
        <Select
          label="Select Asset"
          value={asset}
          name="asset"
          onChange={(v) => setAsset(v)}
          placeholder="Select Asset"
        >
          {BLOCKCHAIN_ASSEST.map((itm) => (
            <SelectItem key={itm.value} value={itm.value}>
              <span>{itm.title}</span>
            </SelectItem>
          ))}
        </Select>
        {isWalletPresent && (
          <Select
            label="Select Network"
            value={network}
            name="network"
            onChange={selectHandler}
            placeholder="Select Network"
          >
            {BLOCKCHAIN_NETWORKS.filter((net) => net.value.includes(asset)).map(
              (itm) => (
                <SelectItem key={itm.value} value={itm.title}>
                  <span>{itm.title}</span>
                </SelectItem>
              )
            )}
          </Select>
        )}

        <div className="pt-9">
          {network && asset ? (
            <>
              <p className="mb-6">{PageDictionary.form.address_label}</p>
              <ClipboardCopy
                walletAddress={
                  network === BLOCKCHAIN_NETWORKS[0].title
                    ? EUSD_WALLET
                    : MOBCOIN_WALLET
                }
                loading={loading}
                network={network}
                asset={asset}
              />
            </>
          ) : null}
        </div>
        <CustomButton className="mt-4 self-start rounded-lg py-3 px-12 text-sm leading-6">
          {PageDictionary.form.submit_btn}
        </CustomButton>
      </form>
    </SideModal>
  );
}

export default FundCryptoForm;
